// extracted by mini-css-extract-plugin
export default {"toolbar":"NH3MS9"};